<!--生产制造-生产准备-丝绵工序配置-->
<template>
  <ls-table-layout>
    <div class="table-page-search-wrapper" slot="search">
      <ls-search-form @search="onSearch" @reset="resetQuery" :formList="formList" ref="refSearchForm">
        <template #organizationCodeTitle>
            <span><i class="toRequired">*</i>组织</span>
        </template>
        <global-select
          v-decorator="['organizationCode']"
          :allow-clear="false"
          slot="organizationCode"
          :value.sync="queryParams.organizationCode"
          selectType="select"
          :selectData="inventOrg"
          :selectItem="{ value: 'realValue', label: 'label' }"
        />
        <global-select
          slot="itemCodes"
          :value.sync="queryParams.itemCodes"
          selectType="selectMultipleSearch"
          requestApi="/mdm/mdmItemSystemItem/itemCodeBox"
          :selectItem="{ value: 'selectedValue', label: 'label' }"
          searchParam="itemCode"
          sourseField="res"
          :totalNum="9999999999"
          :dropdown-match-select-width="false"
        />
        <template v-for="field in ifFieldList">
          <a-select :key="field" :slot="field" v-model="queryParams[field]" allowClear>
            <a-select-option :value="1">是</a-select-option>
            <a-select-option :value="0">否</a-select-option>
          </a-select>
        </template>
      </ls-search-form>
    </div>
    <div slot="btn">
      <a-space>
        <a-button type="primary" v-hasPermi="['bom:bomSmOperationConfigCc:add']" @click="handleAdd">新增</a-button>
        <a-button type="primary" :loading="loading" v-hasPermi="['bom:bomSmOperationConfigCc:import']" @click="handleImport">导入</a-button>
        <a-button type="primary" :loading="loading" v-hasPermi="['bom:bomSmOperationConfigCc:export']" @click="handleExport">导出</a-button>
        <import-excel ref="importExcelRef" :downloadParams="downloadParams" :uploadParams="upload" @refresh="() => handleOk(false)" />
        <download-modal :apiFun="apiOperationConfigCcExport" ref="download" />
        <addRoleModal ref="addRoleModalRef" @refreshFun="handleOk" />
      </a-space>
    </div>
    <template v-slot:table>
      <div class="page-header-content">
        <!-- 表格 -->
        <ls-api-table ref="dataTable" :columns="columns" :tableProps="tableProps" rowKey="id"
                      :scroll="{ fixScreen: true, x: 1000 }">
          <!-- 车工棉和扪工棉编辑 -->
          <template v-for="field in ifFieldList" :slot="field" slot-scope="{ text, record }">
            <span :key="field+'Text'" v-if="!isEdit || currentId !== record.id">{{ text === 1 ? '是' : '否' }}</span>
            <a-select v-else :key="field" v-model="record[field]" :allowClear="false">
              <a-select-option :value="1">是</a-select-option>
              <a-select-option :value="0">否</a-select-option>
            </a-select>
          </template>
          <!-- 备注 -->
          <template slot="remark" slot-scope="{ record, text }">
            <span v-if="!isEdit || currentId !== record.id">{{ text }}</span>
            <a-input v-else type="textarea" v-model="record.remark" placeholder="请输入" :maxLength="200" />
          </template>
          <template slot="dateFormat" slot-scope="data">
            {{ data.text && $moment(data.text).format('YYYY-MM-DD HH:mm:ss') }}
          </template>
          <span slot="operation" slot-scope="text">
            <a v-if="!isEdit || currentId !== text.record.id" v-hasPermi="['bom:bomSmOperationConfigCc:edit']" @click="handleEdit(text.record)">编辑</a>
            <a v-if="isEdit && currentId === text.record.id" @click="handleSave(text.record)">保存</a>
            <a v-if="isEdit && currentId === text.record.id" @click="handleCancel(text.record)" class="ml10">取消</a>
          </span>
        </ls-api-table>
      </div>
    </template>
  </ls-table-layout>
</template>

<script>
import { generateLsTableResData } from '@/utils/util.js'
import cloneDeep from 'lodash.clonedeep'
import addRoleModal from './components/addRoleModal'
import ImportExcel from "@/components/ImportExcel/importExcel"
import DownloadModal from '@/views/components/download-modal/download-modal.vue'
import { mapState } from 'vuex'
import {
  ApiOperationConfigCcEdit,
  apiOperationConfigCcExport,
  apiOperationConfigCcList
} from '@/api/mes/productionPrepare/silkProcessConfig'
import moment from 'moment'

export default {
  name: 'SilkProcessConfig',
  components: { addRoleModal, DownloadModal, ImportExcel },
  computed: {
    ...mapState({
      inventOrg: (state) => state.user.inventOrg,
      organizationCodeOrigin: (state) => state.user.organizationCode
    })
  },
  data() {
    return {
      loading: false,
      apiOperationConfigCcExport,
      ifFieldList: ['automotiveCottonOtzz', 'automotiveCottonTtzz', 'automotiveCompositeCotton', 'menggongCottonOtzz', 'menggongCottonTtzz', 'menggongCompositeCotton'],
      // 用户导入参数
      upload: {
        url: process.env.VUE_APP_API_BASE_URL + '/bom/bomSmOperationConfigCc/import' // 上传的地址
      },
      // 导入模板下载参数
      downloadParams: {
        method: 'post',
        url: 'bom/bomSmOperationConfigCc/template',
        name: `丝绵工序配置导入模板_${moment().format('YYYY-MM-DD')}.xlsx`
      },
      // 表格配置
      tableProps: {
        requestApi: generateLsTableResData(apiOperationConfigCcList, false),
        pageCurrent: true
      },
      isEdit: false,
      currentId: "",
      // 查询参数
      queryParams: {
        organizationCode: undefined,
        itemCodes: undefined,
        automotiveCottonOtzz: undefined,
        automotiveCottonTtzz: undefined,
        automotiveCompositeCotton: undefined,
        menggongCottonOtzz: undefined,
        menggongCottonTtzz: undefined,
        menggongCompositeCotton: undefined
      },
      formList: [
        { label: '组织', decorator: ['organizationCode'], type: 'organizationCode', labelSlot: 'organizationCodeTitle' },
        { label: '物料编码', decorator: ['itemCodes'], type: 'itemCodes' },
        { label: '车工棉1200', decorator: ['automotiveCottonOtzz'], type: 'automotiveCottonOtzz' },
        { label: '车工棉2200', decorator: ['automotiveCottonTtzz'], type: 'automotiveCottonTtzz' },
        { label: '车工复合棉', decorator: ['automotiveCompositeCotton'], type: 'automotiveCompositeCotton' },
        { label: '扪工棉1200', decorator: ['menggongCottonOtzz'], type: 'menggongCottonOtzz' },
        { label: '扪工棉2200', decorator: ['menggongCottonTtzz'], type: 'menggongCottonTtzz' },
        { label: '扪工复合棉', decorator: ['menggongCompositeCotton'], type: 'menggongCompositeCotton' }
      ],
      // 表格字段
      columns: [
        { title: '组织', dataIndex: 'organizationName', align: 'center', width: 140 },
        { title: '物料编码', dataIndex: 'itemCode', align: 'center', width: 140 },
        { title: '物料名称', dataIndex: 'itemName', align: 'center', width: 120 },
        { title: '车工棉1200', dataIndex: 'automotiveCottonOtzz', scopedSlots: { customRender: 'automotiveCottonOtzz' }, align: 'center', width: 100 },
        { title: '车工棉2200', dataIndex: 'automotiveCottonTtzz', scopedSlots: { customRender: 'automotiveCottonTtzz' }, align: 'center', width: 100 },
        { title: '车工复合棉', dataIndex: 'automotiveCompositeCotton', scopedSlots: { customRender: 'automotiveCompositeCotton' }, align: 'center', width: 100 },
        { title: '扪工棉1200', dataIndex: 'menggongCottonOtzz', scopedSlots: { customRender: 'menggongCottonOtzz' }, align: 'center', width: 100 },
        { title: '扪工棉2200', dataIndex: 'menggongCottonTtzz', scopedSlots: { customRender: 'menggongCottonTtzz' }, align: 'center', width: 100 },
        { title: '扪工复合棉', dataIndex: 'menggongCompositeCotton', scopedSlots: { customRender: 'menggongCompositeCotton' }, align: 'center', width: 100 },
        { title: '备注', dataIndex: 'remark', scopedSlots: { customRender: 'remark' }, align: 'center', width: 160 },
        { title: '创建人', dataIndex: 'createName', align: 'center', width: 100 },
        { title: '创建时间', dataIndex: 'createTime', align: 'center', width: 140 },
        {
          title: '操作',
          width: 95,
          align: 'center',
          dataIndex: 'operation',
          scopedSlots: { customRender: 'operation' },
          stickyFixed: 'right'
        }
      ]
    }
  },
  mounted() {
    if(this.organizationCodeOrigin) {
      // 初始化拿左上角组织
      this.queryParams.organizationCode = this.organizationCodeOrigin
      this.$refs.refSearchForm.form.setFieldsValue({ organizationCode: this.queryParams.organizationCode })
    }
    this.onSearch()
  },
  methods: {
    // 导入弹窗
    handleImport() {
      this.$refs.importExcelRef.show()
    },
    // 导出
    handleExport() {
      const params = this.$refs.dataTable.searchParams
      this.$refs.download.openModal(params)
    },
    handleEdit(record) {
      if (this.currentId && record.id !== this.currentId && this.isEdit) {
        this.$message.warning('请保存上次编辑的数据')
        return;
      }
      this.isEdit = true;
      this.currentId = record.id;
    },
    // 保存
    handleSave(record) {
      this.loading = true;
      ApiOperationConfigCcEdit(record).then(res => {
        if (res?.code === 200) {
          this.$message.success('编辑成功')
          this.handleOk(true)
        }
      }).finally(() => {
        this.loading = false
      })
    },
    // 取消
    handleCancel() {
      this.handleOk(true)
    },
    // 新增
    handleAdd() {
      this.$refs.addRoleModalRef.show(this.organizationCodeOrigin)
    },
    // 新增/修改框事件, changePage为true，则不返回到第一页
    handleOk(changePage = false) {
      this.onSearch({ ...this.$refs.refSearchForm.getSearchValue() }, changePage)
    },
    // 表单搜索
    onSearch(value = {}, changePage = false) {
      this.isEdit = false;
      this.currentId = '';
      const params = Object.assign({}, this.queryParams, value)
      delete params.searchFormLabel
      params.organizationCode = this.queryParams.organizationCode // 根据组织查，不置空
      this.$refs.dataTable.searchParams = cloneDeep(params)
      this.$refs.dataTable.getData(changePage)
    },
    // 重置按钮操作
    resetQuery() {
      this.queryParams = {
        organizationCode: this.queryParams.organizationCode,
        itemCodes: undefined,
        automotiveCottonOtzz: undefined,
        automotiveCottonTtzz: undefined,
        automotiveCompositeCotton: undefined,
        menggongCottonOtzz: undefined,
        menggongCottonTtzz: undefined,
        menggongCompositeCotton: undefined
      }
      this.$refs.dataTable.searchParams = this.queryParams
      this.$refs.refSearchForm.form.setFieldsValue(this.queryParams)
    }
  }
}
</script>

<style scoped lang="less"></style>
